<template>
  <v-card class="dialog-container pa-0">
    <v-row no-gutters class="fill-height">
      <v-col class="fill-height" :style="`max-width: calc(100% - ${sidebarWidth}px);`">
        <div class="editor fill-height">
          <MainMenu :editor="editor" />
          <LinkBubbleMenu :editor="editor" v-if="editor" />
          <div class="editor-container">
            <div class="editor-text-container">
              <EditorContent
                class="editor__content"
                :editor="editor"
                :style="'font-size: ' + zoomEm + 'em'"
              />
            </div>
          </div>
        </div>
      </v-col>
      <v-col :style="`max-width: ${sidebarWidth}px;`">
        <Sidebar :editor="editor" class="editor__sidebar" />
      </v-col>
    </v-row>
    <FloatingActionMenu
      v-if="editor"
      :editor="editor"
      @zoom="zoomLevel = $event"
    />
  </v-card>
</template>

<script>
import { Editor, EditorContent } from "@tiptap/vue-2";
import { mapMutations, mapGetters } from "vuex";
import LinkBubbleMenu from "@/components/CreatorTools/StoryHub/ChapterEditor/LinkBubbleMenu.vue";
import FloatingActionMenu from "@/components/CreatorTools/StoryHub/ChapterEditor/FloatingActionMenu";
import MainMenu from "@/components/TextEditor/MainMenu";
import Sidebar from "@/components/TextEditor/Sidebar";
import EXTENSIONS from "@/components/CreatorTools/StoryHub/ChapterEditor/tiptapExtensions";
import { EDITOR_SIDEBAR_WIDTH } from "@/const";

import { ZOOM_EM_STEPS, START_ZOOM } from "@/helpers/tiptapConst";
export default {
  components: {
    EditorContent,
    MainMenu,
    Sidebar,
    FloatingActionMenu,
    LinkBubbleMenu,
  },
  props: {
    text: String,
  },
  computed: {
    ...mapGetters("sharedStoryDescription", ["getText"]),
    zoomEm() {
      return this.zoomLevel * ZOOM_EM_STEPS;
    },
    sidebarWidth() {
      return EDITOR_SIDEBAR_WIDTH;
    },
  },
  methods: {
    ...mapMutations("sharedStoryDescription", ["setText"]),
  },
  data() {
    return {
      editor: null,
      zoomLevel: START_ZOOM,
    };
  },
  mounted() {
    this.editor = new Editor({
      content: this.getText,
      onUpdate: ({ editor }) => {
        this.setText(editor.getHTML());
      },
      extensions: EXTENSIONS,
    });
  },
  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/tiptapEditorShared.scss";
</style>
